import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { TokenIntegrador } from 'src/app/models/token-integrador';
import { CarregandoService } from 'src/app/services/carregando.service';
import { ClienteService } from 'src/app/services/cliente.service';
import { GlobalService } from 'src/app/services/global.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PremissasService } from 'src/app/services/premissas.service';

@Component({
  selector: 'app-token-plataforma-modal',
  templateUrl: './token-plataforma-modal.component.html',
  styleUrls: ['./token-plataforma-modal.component.scss']
})
export class TokenPlataformaModalComponent implements OnInit, OnDestroy {
  dados: TokenIntegrador = new TokenIntegrador();
  copiado: boolean = false;
  escondeSalvar: boolean = false;
  controleSolicitacaoToken: boolean = false;
  tokenSolicitado?: string;
  statusSolicitacaoToken: string;
  intervalId: any;

  constructor(
    private clienteService: ClienteService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private globalService: GlobalService,
    private premissasService: PremissasService,
    public dialogRef: MatDialogRef<TokenPlataformaModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog
  ) { }

  async ngOnInit() {
    await this.buscarPremissaControleSolicitacaoToken();

    const idUser = await this.globalService.consultaUsuario();

    this.buscarUsuario(idUser.id);
  }

  ngOnDestroy() {
    clearInterval(this.intervalId);
  }

  confirmaCopia() {
    this.copiado = !this.copiado;
  }

  buscarUsuario(id) {
    this.carregandoService.mostra('buscaUsuario');
    this.clienteService.consultarTokenPorIdCliente(id, true).subscribe(data => {
      this.carregandoService.esconde('buscaUsuario');
      this.dados = data;
      this.escondeSalvar = this.dados.tokenMP != '' && this.dados.tokenMP != null;
    }, (erro) => {
      this.carregandoService.esconde('buscaUsuario');
      this.notificacaoService.erro(erro);
    });
  }

  buscarPremissaControleSolicitacaoToken() {
    return new Promise((resolve, reject) => {
      this.carregandoService.mostra('buscaPremissaControleSolicitacaoToken');
      this.premissasService.consultarControleSolicitacaoTokenIntegrador().subscribe(
        async (resultado: any) => {
          this.controleSolicitacaoToken = resultado.valor;
          this.carregandoService.esconde('buscaPremissaControleSolicitacaoToken');
          await this.buscarTokenSolicitado();
          resolve();
        }, (erro) => {
          this.carregandoService.esconde('buscaPremissaControleSolicitacaoToken');
          reject();
        });
    });
  }

  gerarTokenMarketPlace() {
    this.carregandoService.mostra('gerarTokenMarketPlace');
    this.clienteService.gerarTokenIntegracao().subscribe((resultado: any) => {
      this.dados.tokenMP = resultado.token;
      this.escondeSalvar = false;
      this.carregandoService.esconde('gerarTokenMarketPlace');
    }, (erro) => {
      this.carregandoService.esconde('gerarTokenMarketPlace');
      this.notificacaoService.erro('Não foi possível gerar o token de HubB2B');
    });
  }

  solicitarCriacaoDeToken() {
    this.carregandoService.mostra('solicitarCriacaoDeToken');
    this.clienteService.solicitarCriacaoDeToken().subscribe(async (resultado: any) => {
      this.carregandoService.esconde('solicitarCriacaoDeToken');
      this.notificacaoService.sucesso('Solicitação de token HubB2B feita com sucesso.');
      this.tokenSolicitado = 'Solicitado';
      this.buscarTokenAguardando();
    }, (erro) => {
      this.carregandoService.esconde('solicitarCriacaoDeToken');
      this.notificacaoService.erro('Não foi possível solicitar o token de HubB2B');
    });
  }

  buscarTokenSolicitado(disableLoading = false) {
    return new Promise((resolve, reject) => {
      if (!disableLoading) {
        this.carregandoService.mostra('buscarTokenSolicitado');
      }

      this.clienteService.consultarTokenSolicitado().subscribe((resultado: any) => {
        this.tokenSolicitado = resultado.token;
        this.carregandoService.esconde('buscarTokenSolicitado');
        resolve();
      }, (erro) => {
        this.carregandoService.esconde('buscarTokenSolicitado');
        console.error(erro);
        reject();
      });
    });
  }

  salvarToken() {
    this.carregandoService.mostra('salvaToken');

    this.clienteService.salvarToken(this.dados.tokenMP).subscribe(data => {
      this.carregandoService.esconde('salvaToken');
      this.fechar();
    }, (erro) => {
      this.carregandoService.esconde('salvaToken');
      this.notificacaoService.erro(erro);
    });
  }

  buscarTokenAguardando() {
    this.intervalId = setInterval(async () => {
      const disableLoading = true;
      await this.buscarTokenSolicitado(disableLoading);
      if (this.tokenSolicitado && this.tokenSolicitado !== '' && this.tokenSolicitado !== 'Solicitado') {
        clearInterval(this.intervalId);
      }
    }, 3000);
  }

  fechar() {
    this.dialogRef.close();
  }

}
